import React, { useMemo, useState } from 'react';
import { PageHeader } from '../components/PageHeader';
import { Section } from '../components/Section';
import { Reveal } from '../components/Reveal';
import { ClosingCTA } from '../components/ClosingCTA';
import { insights, insightCategories, InsightCategory } from '../data/insights';
import { formatInsightDate } from '../utils/format';
type Filter = 'All' | InsightCategory;
export function Insights() {
  const [filter, setFilter] = useState<Filter>('All');
  const visible = useMemo(() => filter === 'All' ? insights : insights.filter(item => item.category === filter), [filter]);
  const filters: Filter[] = ['All', ...insightCategories];
  return <main data-id="element-344" data-mp="2su6n85iyjdtj">
      <PageHeader eyebrow="Insights" title="Market commentary and planning notes, in plain language." lede="Written by the same research desk that maintains our model portfolios. No forecasts we would not act on ourselves." data-id="element-345" data-mp="2stwvacecqwl7" />

      <Section data-id="element-346" data-mp="1hd6lykemtond">
        <div className="flex flex-wrap items-center gap-2" role="group" aria-label="Filter insights by category" data-id="element-347" data-mp="s2y2gmwal785">
          {filters.map(item => {
          const active = filter === item;
          return <button key={item} type="button" onClick={() => setFilter(item)} aria-pressed={active} className={['rounded-sm border px-3.5 py-1.5 text-sm transition-[background-color,border-color,color] duration-200 ease-out-quint', active ? 'border-gold bg-gold text-cream' : 'border-line bg-cream text-charcoal-600 hover:border-charcoal/30 hover:text-charcoal'].join(' ')} data-id="element-348" data-mp="121nlwk3u6zqi">
                {item}
              </button>;
        })}
        </div>

        {visible.length === 0 ? <p className="mt-16 text-center text-charcoal-600" data-id="element-349" data-mp="1pr86f7fn251w">
            No notes in this category yet. Our desk publishes two to three pieces a month.
          </p> : <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-350" data-mp="1wsbrer3bfpvi">
            {visible.map((insight, index) => <Reveal key={insight.slug} delay={Math.min(index, 5) * 0.04} data-id="element-351" data-mp="26ru5iqwjohfn" data-mpi={index}>
                <article className="flex h-full flex-col rounded-sm border border-line bg-cream p-6 transition-[border-color,box-shadow,transform] duration-200 ease-out-quint hover:-translate-y-0.5 hover:border-gold/40 hover:shadow-card" data-id="element-352" data-mp="2bj2fbo1se4tc">
                  <span className="text-[0.7rem] font-medium uppercase tracking-wider text-gold-dark" data-id="element-353" data-mp="2kipl0m1jtws7">
                    {insight.category}
                  </span>
                  <h2 className="mt-3 font-serif text-[1.3rem] leading-snug text-charcoal" data-id="element-354" data-mp="2uhoj5aooua0y">
                    {insight.title}
                  </h2>
                  <p className="mt-3 text-[0.925rem] leading-relaxed text-charcoal-600" data-id="element-355" data-mp="v6do8rb8ud42">
                    {insight.excerpt}
                  </p>
                  <div className="mt-auto flex items-center justify-between gap-3 border-t border-line pt-5 text-xs text-charcoal-400" data-id="element-356" data-mp="sk4kx8zl7h64">
                    <span data-id="element-357" data-mp="nswac9mitprd">{insight.author}</span>
                    <span data-id="element-358" data-mp="iul0hyw87f95">
                      {formatInsightDate(insight.date)} · {insight.readMinutes} min
                    </span>
                  </div>
                </article>
              </Reveal>)}
          </div>}
      </Section>

      <ClosingCTA eyebrow="Research, direct" title="Our quarterly house view, sent to your inbox." body="Families we advise receive the full note. Speak to an adviser to be added to the list." data-id="element-359" data-mp="1biqmeoz0naak" />
    </main>;
}